var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"none_box"},[_c('img',{attrs:{"src":require("@/assets/images/zwdh_img.png")}}),_c('p',[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }